import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { PosOrbitComponent } from './app/pos-orbit.component';

bootstrapApplication(PosOrbitComponent, appConfig).catch(err => console.error(err));
